import { useQuery } from "@tanstack/react-query";
import { forecastVarianceApi } from "../api/forecastVarianceApi";
import { formatCurrency } from "../../../shared/utils";

export const useScopeChange = () => {

    const { data, isLoading, isFetching, error, isError } = useQuery({
        queryKey: ["investment-oversight-scope-change"],
        queryFn: async () => {
            const response = await forecastVarianceApi.fetchScopeChange();
            return response.data;
        }
    });

    const filteredData = data?.filter((value: { programme_name: unknown }) => value.programme_name != null) || [];

    return {
        filteredData,
        chartData: filteredData.map((value: { programme_name: string; changes: number }) => ({
            programme: value.programme_name,
            approvedChanges: value.changes ?? 0
        })),
        isLoading: isLoading || isFetching, error, isError
    }

}